import {
  GetAllUsersResponse,
  GetPrivilegesResponse,
  GetUserResponse,
  CreateUserResponse,
  UpdateUserResponse,
  DeleteUserResponse,
} from '../../types/types';
import { _post, requestType } from './_internal';

export const getPrivileges = (): Promise<GetPrivilegesResponse> => {
  return _post({
    request_type:
      requestType.liste_des_privileges_associes_a_une_categorie_d_utilisateur,
  });
};

export const createUser = (payload: any): Promise<CreateUserResponse> => {
  return _post({
    request_type: requestType.creation_d_un_utilisateur,
    ...payload,
  });
};

export const updateUser = (payload: any): Promise<UpdateUserResponse> => {
  return _post({
    request_type: requestType.modification_d_un_utilisateur,
    ...payload,
  });
};

export const deleteUser = (payload: {
  user_id: string;
}): Promise<DeleteUserResponse> => {
  return _post({
    request_type: requestType.supprimer_un_utilisateur,
    user_id: payload.user_id,
  });
};

export const getAllUsers = (): Promise<GetAllUsersResponse> => {
  return _post({
    request_type: requestType.recuperation_de_la_liste_des_utilisateurs,
  });
};

export const getUser = (payload: {
  user_id: string;
}): Promise<GetUserResponse> => {
  return _post({
    request_type: requestType.recuperation_d_un_utilisateur,
    user_id: payload.user_id,
  });
};
